import { Routes } from '@angular/router';
import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { SearchViewComponent } from './search-view.component';

export const COMPANY_PERSON_SEARCH_ROUTES: Routes = [
  {
    path: ':searchQuery',
    component: SearchViewComponent,
    data: {
      title: extractTranslation('route.search'),
      hideAllBreadcrumbs: true,
    },
  },
  {
    path: '',
    data: {
      title: extractTranslation('route.search'),
      hideAllBreadcrumbs: true,
    },
    component: SearchViewComponent,
  },
];
